import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
// TODO: Move these functions to broadcastStore and refactor other calls to go through the store
export async function fetchAllBroadcasts() {
    const { data, error } = await GalaxyApi().GET("/api/notifications/broadcast");
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function createBroadcast(broadcast) {
    const { data, error } = await GalaxyApi().POST("/api/notifications/broadcast", {
        body: broadcast,
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
export async function updateBroadcast(id, broadcast) {
    const { data, error } = await GalaxyApi().PUT("/api/notifications/broadcast/{notification_id}", {
        params: {
            path: { notification_id: id },
        },
        body: broadcast,
    });
    if (error) {
        rethrowSimple(error);
    }
    return data;
}
